import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatearFecha } from '../utils/fecha';

const COLOR_ESTADO = {
  activa: { fondo: '#f0fdf4', texto: '#166534', punto: '🟢' },
  pendiente: { fondo: '#fffbeb', texto: '#92400e', punto: '🟡' },
  vencida: { fondo: '#fef2f2', texto: '#991b1b', punto: '🔴' },
  suspendida: { fondo: '#f3f4f6', texto: '#4b5563', punto: '⚫' }
};

const PLANES = [
  { meses: 1, nombre: 'Mensual' },
  { meses: 3, nombre: 'Trimestral' },
  { meses: 6, nombre: 'Semestral' },
  { meses: 12, nombre: 'Anual' }
];

export default function AdminEmpresas() {
  const [empresas, setEmpresas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  // Empresa cuya ventana de activación está abierta
  const [activando, setActivando] = useState(null);
  const [meses, setMeses] = useState(12);
  const [nota, setNota] = useState('');

  const cargar = () => {
    setCargando(true);
    axios.get('/api/admin/empresas')
      .then(res => setEmpresas(res.data || []))
      .catch(err => setError(err.response?.data?.error || err.message))
      .finally(() => setCargando(false));
  };

  useEffect(cargar, []);

  const abrirActivacion = (empresa) => {
    setActivando(empresa);
    setMeses(12);
    setNota(empresa.notas || '');
  };

  const confirmarActivacion = async () => {
    try {
      await axios.post(`/api/admin/empresas/${activando.id}/activar`, {
        meses: parseInt(meses, 10),
        notas: nota
      });
      setActivando(null);
      cargar();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.error || err.message));
    }
  };

  const suspender = async (empresa) => {
    if (!window.confirm(
      `¿Suspender a "${empresa.name}"?\n\nPerderá el acceso de inmediato. Sus datos no se borran.`
    )) return;

    const notas = window.prompt('Motivo (opcional):', '') || '';
    try {
      await axios.post(`/api/admin/empresas/${empresa.id}/suspender`, { notas });
      cargar();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.error || err.message));
    }
  };

  if (cargando) return <p className="empty-state">Cargando empresas...</p>;
  if (error) return <p className="empty-state">❌ {error}</p>;

  const pendientes = empresas.filter(e => e.estado === 'pendiente').length;

  return (
    <div className="admin-page">
      <h2>🏢 Empresas suscritas</h2>

      {pendientes > 0 && (
        <div style={{
          background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e',
          padding: '14px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px'
        }}>
          ⏳ <strong>{pendientes}</strong> {pendientes === 1 ? 'empresa espera' : 'empresas esperan'} activación.
        </div>
      )}

      {activando && (
        <div
          onClick={() => setActivando(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', zIndex: 100,
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
            padding: '40px 15px', overflowY: 'auto'
          }}
        >
          <div
            onClick={(ev) => ev.stopPropagation()}
            style={{
              background: 'white', borderRadius: '12px', padding: '25px',
              width: '100%', maxWidth: '440px', boxShadow: '0 10px 40px rgba(0,0,0,.25)'
            }}
          >
            <h3 style={{ marginTop: 0 }}>Activar «{activando.name}»</h3>
            <p style={{ color: '#6b7280', fontSize: '14px', marginTop: 0 }}>
              Elige el plan que pagó. Si renuevas antes de que venza, los meses se
              suman a la fecha actual y no pierde días.
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', margin: '18px 0' }}>
              {PLANES.map(pl => (
                <button
                  key={pl.meses}
                  type="button"
                  onClick={() => setMeses(pl.meses)}
                  style={{
                    padding: '14px 10px', borderRadius: '8px', cursor: 'pointer',
                    border: meses === pl.meses ? '2px solid #667eea' : '1px solid #e5e7eb',
                    background: meses === pl.meses ? '#eef2ff' : 'white',
                    color: meses === pl.meses ? '#4338ca' : '#374151',
                    fontWeight: meses === pl.meses ? 'bold' : 'normal'
                  }}
                >
                  {pl.nombre}
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: 'normal' }}>
                    {pl.meses} {pl.meses === 1 ? 'mes' : 'meses'}
                  </div>
                </button>
              ))}
            </div>

            <label style={{ fontSize: '13px', color: '#6b7280' }}>
              Otro periodo (meses)
            </label>
            <input
              type="number"
              min="1"
              value={meses}
              onChange={(ev) => setMeses(ev.target.value)}
              style={{
                width: '100%', padding: '10px', marginBottom: '15px', marginTop: '5px',
                border: '1px solid #e5e7eb', borderRadius: '6px', boxSizing: 'border-box'
              }}
            />

            <label style={{ fontSize: '13px', color: '#6b7280' }}>
              Nota del pago
            </label>
            <input
              type="text"
              placeholder="Ej: efectivo 29/07, transferencia Bancolombia..."
              value={nota}
              onChange={(ev) => setNota(ev.target.value)}
              style={{
                width: '100%', padding: '10px', marginBottom: '20px', marginTop: '5px',
                border: '1px solid #e5e7eb', borderRadius: '6px', boxSizing: 'border-box'
              }}
            />

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="button"
                onClick={() => setActivando(null)}
                style={{
                  flex: 1, padding: '12px', borderRadius: '6px', cursor: 'pointer',
                  border: '1px solid #e5e7eb', background: 'white', color: '#374151'
                }}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={confirmarActivacion}
                style={{
                  flex: 1, padding: '12px', borderRadius: '6px', border: 'none',
                  background: '#10b981', color: 'white', fontWeight: 'bold', cursor: 'pointer'
                }}
              >
                ✅ Activar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="table-container">
        <table className="clients-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Empresa</th>
              <th>Correo</th>
              <th>Estado</th>
              <th>Vence</th>
              <th>Restan</th>
              <th>Clientes</th>
              <th>Nota</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {empresas.map(e => {
              const c = COLOR_ESTADO[e.estado] || COLOR_ESTADO.pendiente;
              return (
                <tr key={e.id}>
                  <td>{e.id}</td>
                  <td><strong>{e.name}</strong></td>
                  <td style={{ fontSize: '13px' }}>{e.email || '-'}</td>
                  <td>
                    <span style={{
                      background: c.fondo, color: c.texto, padding: '4px 10px',
                      borderRadius: '12px', fontSize: '12px', fontWeight: 'bold',
                      whiteSpace: 'nowrap'
                    }}>
                      {c.punto} {e.estado}
                    </span>
                  </td>
                  <td style={{ fontSize: '13px' }}>
                    {e.activa_hasta ? formatearFecha(e.activa_hasta) : '-'}
                  </td>
                  <td style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
                    {e.dias_restantes === null || e.dias_restantes === undefined ? '-'
                      : e.dias_restantes >= 0
                        ? <span style={{ color: e.dias_restantes <= 3 ? '#b45309' : '#6b7280' }}>
                            {e.dias_restantes} días
                          </span>
                        : <span style={{ color: e.fuera_de_prorroga ? '#991b1b' : '#b45309' }}>
                            vencida hace {Math.abs(e.dias_restantes)} d
                            {e.fuera_de_prorroga && ' · sin prórroga'}
                          </span>}
                  </td>
                  <td>{e.clientes}</td>
                  <td style={{ fontSize: '12px', color: '#6b7280', maxWidth: '160px' }}>
                    {e.notas || '-'}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button
                      onClick={() => abrirActivacion(e)}
                      style={{
                        background: '#10b981', color: 'white', border: 'none',
                        borderRadius: '4px', padding: '6px 10px', cursor: 'pointer',
                        fontSize: '12px', marginRight: '6px'
                      }}
                    >
                      {e.estado === 'activa' ? 'Renovar' : 'Activar'}
                    </button>
                    {e.estado !== 'suspendida' && (
                      <button
                        onClick={() => suspender(e)}
                        style={{
                          background: '#ef4444', color: 'white', border: 'none',
                          borderRadius: '4px', padding: '6px 10px', cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        Suspender
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
